import React, { useState } from "react";
import { InputType } from "../../Utils/Utils";
import { SvgImages } from "../../Utils/LocalImages";
import Image from "./Image";

function CustomTextField({
  name,
  register,
  labelTitle,
  placeholder,
  inputType,
  additionalClasses,
  icon,
  showError,
  errorMessage,
  labelTitleText,
  showLabel = true,
  showMandatory = false,
  imageClass,
  labelClass,
  optionalclass,
  ...props
}) {
  const [useType, setUseType] = useState(inputType);
  const [time, setTime] = useState("");
  const [period, setPeriod] = useState("AM");

  const handleTimeChange = (e) => {
    setTime(e.target.value);
  };

  const handlePeriodChange = (e) => {
    setPeriod(e.target.value);
  };

  return (
    <div className={`form-group mb-3 d-flex flex-column ${optionalclass}`}>
      {
        showLabel && (
          <label htmlFor="exampleInputEmail1 " className={`login_heading ${labelClass}`}>
            {labelTitle}
            {showMandatory ? (
              <span className={`danger ${labelTitleText ? "filelebeltext" : ""}`}>
                {labelTitleText || "*"}
              </span>
            ) : null}
          </label>
        )
      }
   
      <div className={` ${useType === "file" ? additionalClasses : ""} position-relative`}>
        <Image src={icon} className={`input_icons ${imageClass}`}></Image>
        {useType === "day" ? (
          <select
            className={`${additionalClasses} form-control`}
            {...props}
            {...(register ? register(name) : {})}
          >
            <option value="">Select a day</option>
            <option value="Sunday">Sunday</option>
            <option value="Monday">Monday</option>
            <option value="Tuesday">Tuesday</option>
            <option value="Wednesday">Wednesday</option>
            <option value="Thursday">Thursday</option>
            <option value="Friday">Friday</option>
            <option value="Saturday">Saturday</option>
          </select>
        ) : useType === "time" ? (
          <input
            type="time"
            className={`${additionalClasses} form-control`}
            {...props}
            {...(register ? register(name) : {})}
            value={props.value}
          />
        ) : (<input
          type={useType}
          className={`${useType === "file" ? "" : `${additionalClasses} form-control`
            } ${inputType === InputType.password ? "pe-5" : ""}`}
          placeholder={placeholder}
          {...props}
          {...(register ? register(name) : {})}
          
        />
        )}
        {inputType == InputType.password ? (
          <Image
            className="eye_icon2 cursor-pointer"
            src={
              useType != InputType.password
                ? SvgImages.password_show
                : SvgImages.password_hide
            }
            onClick={() => {
              setUseType(
                useType == InputType.password
                  ? InputType.text
                  : InputType.password
              );
            }}
          />
        ) : null}
      </div>

      {showError ? (
        <span className="danger fs-14 fw-400 mt-1">{errorMessage}</span>
      ) : null}
    </div>
  );
}

export default CustomTextField;
